export default "__VITE_ASSET__DYISvU0N__"